import Mun from "./Mun"

class Player extends Mun {
}

export default Player
